import classNames from 'classnames';
import { ButtonHTMLAttributes, RefObject } from 'react';

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> & {
  showDropdownIcon?: boolean;
  label: string;
  icon?: string;
  e2ePrefix: string;
  ref: RefObject<HTMLButtonElement | null>;
  isReadonly?: boolean;
};
export function ToggleButton({
  showDropdownIcon = true,
  label,
  icon = 'person',
  e2ePrefix,
  className,
  ref,
  isReadonly,
  ...props
}: Props) {
  return (
    <button
      {...props}
      type="button"
      data-e2e={`${e2ePrefix}-selector-dropdown`}
      className={classNames('h-100 d-flex flex-grow-1 btn min-width-0', className)}
      title={label}
      onClick={e => {
        if (isReadonly) {
          e.preventDefault();
        } else {
          props.onClick?.(e);
        }
      }}
      ref={ref}
    >
      <span className="d-inline-flex justify-content-start min-width-0">
        <i className="icon icon-sm me-2">{icon}</i>
        <div className="text-truncate min-width-0">{label}</div>
      </span>
      {showDropdownIcon && <i className="icon">arrow_drop_down</i>}
    </button>
  );
}
